// src/components/CaseList.js

import React from "react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Edit, Trash2 } from "lucide-react";

export default function CaseList({ cases, handleEditCase, handleDeleteCase }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {cases.map((caseItem) => (
                <Card key={caseItem.id}>
                    <CardContent className="p-4">
                        <h3 className="text-lg font-semibold mb-2">
                            {caseItem.title}
                        </h3>
                        <div className="text-sm space-y-1 mb-4">
                            <p>Industry: {caseItem.industry}</p>
                            <p>Type: {caseItem.caseType}</p>
                            <p>Time: {caseItem.expectedTime} minutes</p>
                            <p>
                                Interviewer Led:{" "}
                                {caseItem.isInterviewerLed ? "Yes" : "No"}
                            </p>
                            <p>Difficulty: {caseItem.difficulty}</p>
                        </div>

                        {/* Tags */}
                        {caseItem.tags?.length > 0 && (
                            <div className="mb-2">
                                <p className="font-medium text-sm">Tags:</p>
                                <div className="flex flex-wrap gap-1">
                                    {caseItem.tags.map((tag, index) => (
                                        <span
                                            key={index}
                                            className="px-2 py-1 bg-gray-100 rounded text-xs">
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Key Points */}
                        {caseItem.keyPoints?.length > 0 && (
                            <div className="mb-2">
                                <p className="font-medium text-sm">
                                    Key Points:
                                </p>
                                <ul className="list-disc pl-4">
                                    {caseItem.keyPoints.map((kp, idx) => (
                                        <li key={idx}>{kp.title}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {/* Questions */}
                        {caseItem.caseQuestions?.length > 0 && (
                            <div className="mt-2">
                                <p className="font-medium text-sm">
                                    Questions: {caseItem.caseQuestions.length}
                                </p>
                            </div>
                        )}

                        {/* Edit & Delete */}
                        <div className="flex justify-end space-x-2 mt-4">
                            <Button
                                onClick={() => handleEditCase(caseItem.id)}
                                variant="outline"
                                size="sm">
                                <Edit className="w-4 h-4 mr-1" />
                                Edit
                            </Button>
                            <Button
                                onClick={() => handleDeleteCase(caseItem.id)}
                                variant="destructive"
                                size="sm">
                                <Trash2 className="w-4 h-4 mr-1" />
                                Delete
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
}
